<template>
    <v-tab-item :value="$route.path" class="pa-3">
        <v-data-table
            ref="datatable"
            :headers="stores"
            :items="products"
            :loading="loading"
            class="b-outlined pps-dt"
            hide-default-header
            hide-default-footer
            fixed-header
            disable-pagination
        >
            <template v-slot:header="{ props: { headers } }">
                <thead
                    class="v-data-table-header"
                    :class="{ 'fixed-top': scrollPosXY[0] > 210 }"
                >
                    <tr>
                        <th scope="col"></th>
                        <th
                            v-for="header in headers"
                            :key="header.value"
                            scope="col"
                        >
                            {{ header.text }}
                        </th>
                    </tr>
                    <tr>
                        <th scope="col"></th>
                        <th
                            v-for="(header, index) in headers"
                            :key="index"
                            scope="col"
                        >
                            <v-checkbox
                                v-model="header.updateAll"
                                v-if="index != 0"
                                color="secondary"
                                @change="
                                    () => {
                                        updatingStore = header;
                                        updateAllDialog = true;
                                    }
                                "
                            ></v-checkbox>
                        </th>
                    </tr>
                </thead>
            </template>
            <template v-slot:item="row">
                <tr>
                    <td :class="{ 'fixed-left': scrollPosXY[1] }">
                        <div>
                            <b>{{ row.item.name }}</b>
                        </div>
                    </td>
                    <td v-for="(store, index) in stores" :key="index">
                        <v-checkbox
                            v-if="index != 0"
                            v-model="row.item[store.text]"
                            @change="
                                openCheckboxModal(
                                    row.item,
                                    store.text,
                                    row.item[store.text]
                                )
                            "
                            color="secondary"
                        ></v-checkbox>
                    </td>
                </tr>
            </template>

            <template v-slot:top>
                <v-row
                    class="ml-0 mr-0 v-data-footer"
                    style="border-bottom: thin solid rgba(0, 0, 0, 0.12);"
                >
                    <v-col cols="4" class="d-flex">
                        <div class="d-flex flex-column align-center full-width">
                            <div class="full-width  pa-2">
                                <b-search-field
                                    :label="translations.searchStores[lang]"
                                    v-model="storesSearch"
                                ></b-search-field>
                            </div>
                            <div class="full-width pa-2">
                                <b-search-field
                                    class="full-width"
                                    :label="translations.searchProducts[lang]"
                                    v-model="productsSearch"
                                ></b-search-field>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="4"> </v-col>
                    <v-col cols="4" class="d-flex  justify-end">
                        <div class="d-flex flex-column align-center">
                            <span class="pa--5 v-pagination__item"
                                >{{ translations.products[lang] }}:
                                {{ productsPaginationText }}</span
                            >
                            <v-pagination
                                style="min-width: 325px;"
                                v-model="productsPage"
                                :length="productsPagination.total_pages"
                                :total-visible="5"
                            ></v-pagination>
                        </div>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:footer>
                <v-row class="ml-0 mr-0 v-data-footer">
                    <v-col cols="4" class="d-flex"> </v-col>
                    <v-col cols="4"> </v-col>
                    <v-col cols="4" class="d-flex justify-end">
                        <div class="d-flex flex-column align-center">
                            <span class="pa--5 v-pagination__item"
                                >{{ translations.stores[lang] }}:
                                {{ storesPaginationText }}</span
                            >
                            <v-pagination
                                style="min-width: 325px;"
                                v-model="storesPage"
                                :length="storesPagination.total_pages"
                                :total-visible="5"
                            ></v-pagination>
                        </div>
                    </v-col>
                </v-row>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500" persistent>
            <b-card
                :title="checkboxDialogTitle"
                :submit-text="{ el: 'OK', en: 'OK', it: 'OK' }"
                @cancel="closeCheckboxModal()"
                @submit="sendCheckboxValue()"
            >
                <div class="subtitle-1 font-weight-medium py-3">
                    {{
                        (changingCheckbox.value
                            ? translations.addStoreText[lang]
                            : translations.removeStoreText[lang]) +
                            changingCheckbox.productName +
                            (changingCheckbox.value
                                ? translations.to[lang]
                                : translations.from[lang]) +
                            changingCheckbox.storeName
                    }}?
                </div>
            </b-card>
        </v-dialog>

        <v-dialog v-model="updateAllDialog" max-width="500" persistent>
            <b-card
                :title="checkboxDialogTitle"
                :submit-text="{ el: 'OK', en: 'OK', it: 'OK' }"
                @cancel="
                    () => {
                        updateAllDialog = false;
                        updatingStore = {};
                    }
                "
                @submit="
                    () => {
                        addRemoveAll({
                            product_id: updatingStore.id,
                            enable: updatingStore.updateAll
                        });
                        updateAllDialog = false;
                        updatingStore = {};
                    }
                "
            >
                <div class="subtitle-1 font-weight-medium py-3">
                    <span v-if="updatingStore.updateAll">
                        {{
                            translations.addAllStoresText[lang] +
                                updatingStore.text +
                                translations.addAllStoresText2[lang]
                        }}
                    </span>
                    <span v-else>
                        {{
                            translations.removeFromAllStoresText[lang] +
                                updatingStore.text +
                                translations.removeFromAllStoresText2[lang]
                        }}
                    </span>
                </div>
            </b-card>
        </v-dialog>
    </v-tab-item>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import debounce from "lodash/debounce";
import translations from "@/utils/translations/loyaltyPanel/products/productsPerStore";

export default {
    name: "ProductsPerStore",

    mixins: [translations],

    data() {
        return {
            productsPage: +this.$route.query.products_page,
            storesPage: +this.$route.query.stores_page,
            changingCheckbox: {
                storeName: "",
                productName: "",
                storeId: null,
                value: false
            },
            productsSearch: "",
            storesSearch: "",
            updateAllDialog: false,
            updatingStore: {},
            scrollPosXY: []
        };
    },

    computed: {
        ...mapState(["loading", "errorMessage", "serverItemsLength"]),
        ...mapState("loyaltyPanel/productsPerStore", [
            "products",
            "stores",
            "storesPagination",
            "productsPagination",
            "companyProducts"
        ]),

        lang() {
            return this.$route.params.lang;
        },

        checkboxDialogTitle() {
            return this.translations.checkboxDialogTitle[this.lang];
        },

        storesPaginationText() {
            return this.getPaginationText("stores");
        },

        productsPaginationText() {
            return this.getPaginationText("products");
        },

        productsQuery() {
            let query = "?";

            for (let key in this.$route.query) {
                if (key.startsWith("products_")) {
                    query += `${key.replace("products_", "")}=${
                        this.$route.query[key]
                    }&`;
                }
            }

            return query.slice(0, query.length - 1);
        },

        storesQuery() {
            let query = "?";

            for (let key in this.$route.query) {
                if (key.startsWith("stores_")) {
                    query += `${key.replace("stores_", "")}=${
                        this.$route.query[key]
                    }&`;
                }
            }

            return query.slice(0, query.length - 1);
        },

        dialog: {
            get() {
                return this.$store.state.dialog;
            },

            set(val) {
                this.setDialog(val);
            }
        }
    },

    methods: {
        ...mapActions("loyaltyPanel/productsPerStore", [
            "getItems",
            "updateCheckbox",
            "addRemoveAll"
        ]),
        ...mapMutations(["setDialog"]),
        getPaginationText(type) {
            return this[type + "Pagination"].current_page &&
                this[type + "Pagination"].total
                ? `${this[type + "Pagination"].current_page * 12 - 11}-${
                      this[type + "Pagination"].current_page * 12 <=
                      this[type + "Pagination"].total
                          ? this[type + "Pagination"].current_page * 12
                          : this[type + "Pagination"].total
                  } ${this.translations.paginationText[this.lang]} ${
                      this[type + "Pagination"].total
                  }`
                : ``;
        },
        openCheckboxModal(row, name, value) {
            this.changingCheckbox.storeName = row.name;
            this.changingCheckbox.productName = name;
            this.changingCheckbox.value = value;
            this.changingCheckbox.storeId = row.id;
            this.dialog = true;
        },

        sendCheckboxValue() {
            let body = {
                stores_store_id: this.changingCheckbox.storeId,
                parent_product_id: this.companyProducts.filter(
                    item =>
                        item.product_name[this.lang] ==
                        this.changingCheckbox.productName
                )[0].product_id
            };
            this.updateCheckbox(body);
        },

        handleSearch() {
            let props = {
                lang: this.lang,
                storesQuery: this.storesSearch
                    ? `?q=${this.storesSearch}`
                    : this.storesQuery,
                productsQuery: this.productsSearch
                    ? `?q=${this.productsSearch}`
                    : this.productsQuery
            };
            this.getItems(props);
        },

        closeCheckboxModal() {
            this.products.filter(
                item => item.name == this.changingCheckbox.storeName
            )[0][this.changingCheckbox.productName] = !this.products.filter(
                item => item.name == this.changingCheckbox.storeName
            )[0][this.changingCheckbox.productName];
            this.dialog = false;
        }
    },

    beforeCreate() {
        if (!this.$route.query.productPage) {
            this.$router.replace({
                query: {
                    products_page: 1,
                    stores_page: 1,
                    ...this.$route.query
                }
            });
        }
    },

    async mounted() {
        let props = {
            lang: this.lang,
            productsQuery: this.productsQuery,
            storesQuery: this.storesQuery
        };

        await this.getItems(props);
        let scrollEl = this.$refs.datatable?.$el.children[0];
        this._scrollListener = () => {
            this.scrollPosXY = [
                parseInt(window.scrollY),
                parseInt(scrollEl?.scrollLeft)
            ];
        };
        this._scrollListener();
        scrollEl?.addEventListener("scroll", this._scrollListener);
        window.addEventListener("scroll", this._scrollListener);
    },

    watch: {
        productsPage(products_page) {
            this.$router.replace({
                query: { ...this.$route.query, products_page }
            });
            let props = {
                lang: this.lang,
                productsQuery: this.productsQuery,
                storesQuery: this.storesQuery
            };

            this.getItems(props);
        },

        storesPage(stores_page) {
            this.$router.replace({
                query: { ...this.$route.query, stores_page }
            });
            let props = {
                lang: this.lang,
                productsQuery: this.productsQuery,
                storesQuery: this.storesQuery
            };

            this.getItems(props);
        },

        productsSearch(products_q) {
            
            if (products_q == null) {
                let props = {
                    lang: this.lang,
                    productsQuery: this.productsQuery,
                    storesQuery: this.storesQuery
                };
                this.getItems(props);
            } else {
                this.$router.replace({
                    query: { ...this.$route.query, products_q }
                });
                this.debouncedSearch();
            }
        },

        storesSearch(stores_q) {
          
            if (stores_q == null) {
                let props = {
                    lang: this.lang,
                    productsQuery: this.productsQuery,
                    storesQuery: this.storesQuery
                };
                this.getItems(props);
            } else {
                this.$router.replace({
                    query: { ...this.$route.query, stores_q }
                });
                this.debouncedSearch();
            }
        }
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
    }
};
</script>
<style>
.v-pagination * {
    box-shadow: none;
}
.v-pagination__item {
    box-shadow: none;
}
.v-application .primary {
    background-color: #2a3042 !important;
    border-color: #2a3042 !important;
}
</style>
<style scoped>
.fixed-left {
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    left: 0;
    width: 120px;
    background: white;
    z-index: 10;
    min-height: 67px;
}
.fixed-left div {
    min-height: 100%;
    display: flex;
    align-items: center;
}
.full-width {
    width: 100%;
}
</style>
